import React from "react";
import {
  fieldTypes,
  SchemaFactoryV2,
  EnumSingleSelectFieldV2,
} from "@ucl/library";
import {
  IBoltTaskTemplate,
  INewBoltTaskTemplate,
  TaskExecutionTypeFieldSchema,
} from "@bolt/core";
import { TaskExecutionTemplateFieldsComponent } from "../TaskExecutionTypeComponent/TaskExecutionTemplateFieldsComponent";

interface TaskExecutionTypeFieldsSectionProps {
  taskTemplate: IBoltTaskTemplate | INewBoltTaskTemplate;
  updateTaskTemplate: (
    taskTemplate: IBoltTaskTemplate | INewBoltTaskTemplate
  ) => void;
  taskExecutionTypeOptions?: fieldTypes.Option<string>[];
  taskExecutionTypeData?: TaskExecutionTypeFieldSchema;
  updateTaskExecutionTypeData?: (
    updatedModel: TaskExecutionTypeFieldSchema
  ) => void;
  // fetchSchemaForTaskExecutionType?: (typeName: string) => Promise<void>;
  factory: SchemaFactoryV2;
  getAuthRequestHeader: () => Promise<Record<string, string> | undefined>;
  apiBaseUrl: string;
  errors?: { [key: string]: string[] };
}

export const TaskExecutionTypeFieldsSection: React.FC<
  TaskExecutionTypeFieldsSectionProps
> = ({
  taskTemplate,
  updateTaskTemplate,
  taskExecutionTypeOptions,
  taskExecutionTypeData,
  getAuthRequestHeader,
  updateTaskExecutionTypeData,
  // fetchSchemaForTaskExecutionType,
  apiBaseUrl,
  factory,
  errors,
}) => {
  const handleActionTypeChange = async (value: string) => {
    // const typesToFetch = value.filter(
    //   (type) => !(taskExecutionTypeData && type in taskExecutionTypeData)
    // );

    // await Promise.all(
    //   typesToFetch.map((type) => fetchSchemaForTaskExecutionType?.(type))
    // );

    updateTaskTemplate({
      ...taskTemplate,
      taskExecutionType: value,
      // taskExecutionTypes: value,
    });
  };

  return (
    <>
      <EnumSingleSelectFieldV2
        type="EnumSingleSelect"
        label="Task Execution Type"
        placeholder="Select..."
        optionValues={taskExecutionTypeOptions || []}
        value={taskTemplate.taskExecutionType}
        onSubmit={async (value) => {
          await handleActionTypeChange(value as string);
        }}
      />

      {/* {(taskTemplate.taskExecutionTypes ?? []).map((taskExecutionType) => ( */}
      {taskTemplate.taskExecutionType && (
        <TaskExecutionTemplateFieldsComponent
          key={taskTemplate.taskExecutionType}
          taskExecutionType={taskTemplate.taskExecutionType}
          entityType={taskTemplate.entityType || ""}
          fieldSet="TaskExecutionTypeContext"
          taskExecutionTypeData={taskExecutionTypeData}
          factory={factory}
          getAuthRequestHeader={getAuthRequestHeader}
          apiBaseUrl={apiBaseUrl}
          errors={errors}
          updateTaskExecutionTypeData={updateTaskExecutionTypeData}
        />
      )}
      {/* ))} */}
    </>
  );
};
